import { ClockIcon } from 'assets/icons';
import useAppointmentPanel from 'hooks/useAppointmentPanel';
import useTaskPanels from 'hooks/useTaskPanels';
import { useNavigate } from 'react-router-dom';

const LOOK = 'flex min-w-0 max-w-[190px] items-center gap-2 font-medium text-yellow-800';

// What comes next for a company (« Rappel 14:30 », « Relancer en janv. »),
// behind a clock, in the orange of the prototype's « Action à faire ».
// `nextAction` (as the api sends it): a task or an appointment opens its
// panel on a click, in place of the row it sits in; a callback opens the
// company's call sheet in the prospection mode (`companyId`), without dialing.
const CompanyAction = ({ children, nextAction = null, companyId = null }) => {
  const { openTask } = useTaskPanels();
  const navigate = useNavigate();
  const { openAppointment } = useAppointmentPanel();
  const content = (
    <>
      <span className="flex shrink-0 text-gray-900">
        <ClockIcon wh={18} color="currentColor" />
      </span>
      <span className="truncate">{children}</span>
    </>
  );
  const open =
    nextAction?.kind === 'task'
      ? () => openTask(nextAction.id)
      : nextAction?.kind === 'appointment'
        ? () => openAppointment(nextAction.id)
        : nextAction?.kind === 'callback' && companyId
          ? () => navigate(`/prospection?appeler=${companyId}`)
          : null;
  if (!open) return <span className={LOOK}>{content}</span>;
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        open();
      }}
      className={`${LOOK} rounded text-left hover:underline`}
    >
      {content}
    </button>
  );
};

export default CompanyAction;
